import React from "react";
import useWithStore from "@/Hooks/useWithStore";
import {useModalStore as useModalStoreProfile} from "@/Stores/Site/Profile";
import {useBasketStore} from "@/Stores/Site/Basket";
import {selectorOpenProfileDrawer} from "@/Stores/Site/Profile/Selectors";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import BasketButton from "@/Components/Site/BasketButton";
import "@/Scss/mobileNavBar.scss";

const MobileNavBar = (props) => {
    const {stores = {}, authCheck = false, user = {}} = props
    const {subMenuStore = {}, favouritesStore = {}} = stores;
    const {ordersCount = 0, refundsCount = 0} = user;

    const active_orders = ordersCount + refundsCount;

    const basketCount = useBasketStore(state => state.basketCount);
    const openProfileDrawer = useModalStoreProfile(selectorOpenProfileDrawer);

    return (
        <div className={`mobileNavBar`}>
            <div className={`mobileNavBar__wrapper`}>
                <Link
                    href={`/`}
                    onClick={() => {subMenuStore.closeMobileSubMenu()}}
                    className={`mobileNavBar__item`}
                >
                    <div className={`mobileNavBar__icon`}>
                        <Svg id={`homeRoundedIcon`} className={`svg__home`} />
                    </div>
                    <p className={`mobileNavBar__title`}>Главная</p>
                </Link>
                <div className={`mobileNavBar__item`} onClick={() => {subMenuStore.changeMobileSubMenu()}}>
                    <div className={`mobileNavBar__icon`}>
                        <Svg id={`catalog`} className={`svg__home`} />
                    </div>
                    <p className={`mobileNavBar__title`}>Каталог</p>
                </div>
                <Link
                    href={`/favorites`}
                    onClick={() => {subMenuStore.closeMobileSubMenu()}}
                    className={`mobileNavBar__item`}
                >
                    <div className={`mobileNavBar__icon`}>
                        <Svg id={`favoriteBorderOutlinedIcon`} className={`svg__heart`} />
                        {favouritesStore.favouritesData.length !== 0 && (
                            <div className={`mobileNavBar__iconDots`}></div>
                        )}
                    </div>
                    <p className={`mobileNavBar__title`}>Избранное</p>
                </Link>
                <BasketButton className={`mobileNavBar__item inertiaButton`}>
                    <div className={`mobileNavBar__icon`} onClick={() => {subMenuStore.closeMobileSubMenu()}}>
                        <Svg id={`basketBlack`} className={`svg__basketBlack`} />
                        {basketCount !== 0 &&
                            <div className={`mobileNavBar__basketCount`}>{basketCount}</div>
                        }
                    </div>
                    <p className={`mobileNavBar__title`}>Корзина</p>
                </BasketButton>
                <div className={`mobileNavBar__item`}
                     onClick={() => {
                         openProfileDrawer()
                         subMenuStore.closeMobileSubMenu()
                     }}>
                    <div className={`mobileNavBar__icon`}>
                        <Svg id={`profileBlack`} className={`svg__profileBlack`} />
                        {authCheck && active_orders !== 0 && (<div className={`profileDots`}></div>)}
                    </div>
                    <p className={`mobileNavBar__title`}>Профиль</p>
                </div>
            </div>
        </div>
    );
}

export default useWithStore(MobileNavBar);
